import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Label, TextInput, Button } from 'flowbite-react';
import { HiMail } from 'react-icons/hi';
import { observer } from 'mobx-react-lite';
import { authStore } from '../stores/authStore';
import { toastStore } from '../stores/toastStore';

const ForgotPasswordPage: React.FC = observer(() => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const output = await authStore.requestPasswordReset(email);

      if (output.nextStep.resetPasswordStep === 'CONFIRM_RESET_PASSWORD_WITH_CODE') {
        toastStore.showSuccess('確認コードをメールで送信しました');
        navigate(`/reset-password?email=${encodeURIComponent(email)}`);
      } else {
        toastStore.showSuccess('リクエストが完了しました');
      }
    } catch (error) {
      // Error already handled in authStore
      if (authStore.error) {
        toastStore.showError(authStore.error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card>
      <form onSubmit={handleSubmit} className="space-y-4">
        <h2 className="text-2xl font-bold text-gray-900">パスワードをお忘れですか？</h2>
        <p className="text-sm text-gray-600">
          登録されているメールアドレスを入力してください。パスワードリセット用の確認コードを送信します。
        </p>

        <div>
          <Label htmlFor="email" value="メールアドレス" />
          <TextInput
            id="email"
            type="email"
            icon={HiMail}
            placeholder="email@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={isLoading}
          />
        </div>

        <Button
          type="submit"
          className="w-full"
          disabled={isLoading}
          isProcessing={isLoading}
        >
          確認コードを送信
        </Button>

        <div className="text-center">
          <button
            type="button"
            onClick={() => navigate('/login')}
            className="text-sm text-blue-600 hover:underline"
            disabled={isLoading}
          >
            ログイン画面に戻る
          </button>
        </div>
      </form>
    </Card>
  );
});

export default ForgotPasswordPage;
